import React from 'react';
import styles from './styles.module.css';
import { dumbell } from 'assets/newIcons';
import Text from 'components/shared/Text';
export default function EmptyCard({ message }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <img alt='' src={dumbell} className={styles.dumbellImg} />
        <Text className={styles.text}>{message}</Text>
      </div>
    </div>
  );
}
